import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import styles from './styles';

const useStyles = createUseStyles(styles, 'SectionList');

const AttrFormatter = ({ value, colDef }) => {
    const classes = useStyles();
    return (
        <span className={classes.attrFormatter}>
            {value ? value?.[colDef?.cellRendererParams?.attr] : ''}
        </span>
    );
};

export default memo(AttrFormatter);
